export const GET_STATISTICS_WILDCARDS = "GET_STATISTICS_WILDCARDS";
export const CLEAR_FILTERS_WILDCARDS = "CLEAR_FILTERS_WILDCARDS";